// extracted by mini-css-extract-plugin
module.exports = {"container":"ReactionToggle_container__xMHdA","button":"ReactionToggle_button__tC0Bj"};